import axios from "axios";
import { API_ROOT } from ".";
import { getAuthUser } from "./auth";

const TIERS_API_URL = `${API_ROOT}/tiers`;

function getAuthHeaders(): { Authorization: string } {
  const token = getAuthUser()?.token;
  if (!token) throw new Error("Not authenticated");
  return { Authorization: `Bearer ${token}` };
}

export interface SubscriptionTier {
  id: string;
  subscriptionId: string;
  name: string;
  price: number;
  oldCsaMemberPrice: number;
  spots?: number;
  dependsOn?: string; // tierId
  takesFrom: string[]; // subscriptionIds – each subscriber consumes 1 spot from each (e.g. combo: flowers + veggies)
  /** Set when returned from GET /api/subscriptions */
  isAvailable?: boolean;
}

export async function callFetchTiers(subscriptionId?: string): Promise<SubscriptionTier[]> {
  const token = getAuthUser()?.token;
  const params = subscriptionId ? { subscriptionId } : {};
  const res = await axios.get<SubscriptionTier[]>(TIERS_API_URL, {
    ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {}),
    params,
  });
  return Array.isArray(res.data) ? res.data : [];
}

export async function callCreateTier(data: {
  subscriptionId: string;
  name: string;
  price: number;
  oldCsaMemberPrice: number;
  spots?: number;
  dependsOn?: string;
  takesFrom?: string[];
}): Promise<SubscriptionTier> {
  const res = await axios.post<SubscriptionTier>(TIERS_API_URL, data, {
    headers: getAuthHeaders(),
  });
  return res.data;
}

export async function callUpdateTier(
  id: string,
  data: {
    name?: string;
    price?: number;
    oldCsaMemberPrice?: number;
    spots?: number;
    dependsOn?: string | null;
    takesFrom?: string[] | null;
  }
): Promise<SubscriptionTier> {
  const res = await axios.put<SubscriptionTier>(`${TIERS_API_URL}/${id}`, data, {
    headers: getAuthHeaders(),
  });
  return res.data;
}

export async function callDeleteTier(id: string): Promise<void> {
  await axios.delete(`${TIERS_API_URL}/${id}`, {
    headers: getAuthHeaders(),
  });
}
